module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "weather"
    }
  }, [(!_vm.error) ? _c('div', {
    attrs: {
      "id": "display"
    }
  }, [_c('div', {
    attrs: {
      "id": "top"
    }
  }, [_c('div', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.location))]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm._f("prettyDate")(_vm.testimonyTime)))]), _vm._v(" "), _c('div', {
    staticClass: "status"
  }, [_vm._v(_vm._s(_vm.summary))])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "left-information"
    }
  }, [_c('img', {
    staticClass: "thumbnail",
    attrs: {
      "src": _vm.getThumbnail(_vm.status, 64),
      "alt": _vm.status
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "temperature"
  }, [_vm._v(_vm._s(_vm.temperature))]), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("°C")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "right-information"
    }
  }, [_c('span', [_vm._v("Humidity: " + _vm._s(_vm.humidity) + "%")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Pressure: " + _vm._s(_vm.pressure) + " mb")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Wind speed: " + _vm._s(_vm.wind) + " km/h")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "forecast"
    }
  })]) : _c('div', [_vm._v("Location ID error")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb43f3b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/WeatherCard.vue
// module id = 457
// module chunks = 1